import React, { useState } from 'react';
import { Plus, Play, Pause } from 'lucide-react';
import { Strategy } from '../types/index';
import { StockWatchlist } from '../components/organisms/StockWatchlist';
import { Card } from '../components/atoms/Card';
import { Button } from '../components/atoms/Button';

export const TradingPage: React.FC = () => {
  const [strategies, setStrategies] = useState<Strategy[]>([
    { id: '1', name: 'SMA Crossover', symbol: 'AAPL', status: 'stopped', profit: 234.50 },
    { id: '2', name: 'RSI Oversold', symbol: 'GOOGL', status: 'running', profit: -45.20 },
    { id: '3', name: 'Bollinger Bounce', symbol: 'MSFT', status: 'stopped', profit: 156.75 },
  ]);

  const toggleStrategy = (id: string) => {
    setStrategies(strategies.map(strategy =>
      strategy.id === id
        ? { ...strategy, status: strategy.status === 'running' ? 'stopped' : 'running' }
        : strategy
    ));
  };

  return (
    <div data-testid="trading-page">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Trading & Strategies</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <StockWatchlist />
        </div>

        <div>
          <Card className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Auto Trading Strategies</h2>
              <Button size="sm" data-testid="create-strategy-button">
                <Plus size={16} />
                New Strategy
              </Button>
            </div>

            <div className="space-y-4">
              {strategies.map(strategy => (
                <div
                  key={strategy.id}
                  className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
                  data-testid={`strategy-${strategy.id}`}
                >
                  <div>
                    <h3 className="font-medium text-gray-900 dark:text-white">{strategy.name}</h3>
                    <p className="text-sm text-gray-600 dark:text-gray-300">{strategy.symbol}</p>
                    <p className={`text-sm ${strategy.profit >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                      P&L: ${strategy.profit.toFixed(2)}
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    <span
                      className={`px-2 py-1 text-xs rounded-full ${strategy.status === 'running'
                        ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
                        : 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300'
                        }`}
                    >
                      {strategy.status}
                    </span>
                    <Button
                      size="sm"
                      variant={strategy.status === 'running' ? 'danger' : 'success'}
                      onClick={() => toggleStrategy(strategy.id)}
                      data-testid={`toggle-strategy-${strategy.id}`}
                    >
                      {strategy.status === 'running' ? <Pause size={16} /> : <Play size={16} />}
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};